import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import {
    SettingType,
    Widget,
} from '@appblocks/codegeneration/types';
import BaseWidget, { sizes } from '@appblocks/codegeneration/Widgets/BaseWidget';

export default class BarWidget extends BaseWidget {
    constructor() {
        super();
        this.name = 'Bar Widget';
        this.id = 'bar_widget';
        this.minW = sizes[this.id].minW;
        this.minH = sizes[this.id].minH;

        const settings = this.getWidgetSettings(['VARIABLE', 'LABEL', 'MIN', 'MAX', 'DECIMAL_PLACES', 'IS_HORIZONTAL']);

        this.settings = this.settings.concat(settings);
    }

    setSettingValue(settingId: string, settingValue: any): void {
        if (settingId === 'IS_HORIZONTAL') {
            if (settingValue === '1') {
                this.minH = 2;
                this.minW = 2;
            } else {
                this.minW = 1;
                this.minH = 4;
            }
        }
        super.setSettingValue(settingId, settingValue);
    }
}
